import React, { useState, useMemo, useEffect, useContext } from "react";
import TableStyle from "components/Content/Table/TableStyle.module.css";
import MUIDataTable from "components/mui-datatable";
import TableAllData from "components/Content/CustomTable/TableAllData";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import ModalStyles from "components/Content/Modal/ModalStyles.module.css";
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import AximTooltip from "components/AximTooltip";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Slide,
    TextField,
    Grid,
    Chip,
    IconButton,
    InputLabel,
    Select,
    MenuItem,
    FormControl,
    List,
    ListItem,
    Divider,
    ListItemText,
    Typography,
    ListItemButton,
    Collapse

} from "@mui/material";

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
//import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import ButtonStyle from "components/Button/ButtonStyle.module.css";
import { Box } from "@mui/material";
import { apiGet, apiPost } from "app/Services/ApiService";
import { apiUrls, primeApiUrls } from "common/ApiUrls";
import LoaderAnimation from "pages/LoaderAnimation";
import { Utils } from "common/Utils";
import _ from 'lodash';
import moment from "moment";
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import ContractUsers from "components/Pages/ContractUsers";
import dayjs from 'dayjs';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
export default function ComplianceMangement(props) {
    const validationSchema = Yup.object().shape({
        complianceType: Yup.string().trim().required("Compliance Type is required"),
        status: Yup.string().trim().required("Status is required"),
        beginDate: Yup.date().default(null)
            .typeError('Invalid begin date')
            .required('Begin Date is required')
            .min(dayjs().subtract(1, 'month'), 'Begin Date cannot be ealier than a month of current month'),
        endDate: Yup.date().default(null)
            .required('End Date is required')
            .typeError('Invalid end date')
            .when("beginDate",
                (beginDate, yup) => {
                    if (beginDate instanceof Date && !isNaN(beginDate)) {//invalid date
                        return (beginDate && yup.min(beginDate, "End Date cannot be before Begin Date"))
                    }
                })
    });

    const changeToUsersTab = () => {
        let companyId = currentCompany
        setOpenUser(true)
        // if(companyId!=null){
        //     window.location.href = '/ap3/contract-users';
        // }
    };


    const {
        register,
        control,
        handleSubmit,
        reset,
        setValue,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(validationSchema)
    });

    const onSubmit = data => {
        console.dir(contract)
        if (contract.beginDate != null) {
            contract.beginDate = moment(contract.beginDate).toDate()
        }
        if (contract.endDate != null) {
            contract.endDate = moment(contract.endDate).toDate()
        }
        console.dir(contract)
    };

    const [savingData, setSavingData] = React.useState(false)
    const newContract = {
        "contractRateID": Utils.emptyGuid(),
        "contractID": Utils.emptyGuid(),
        "fringeGroupID": Utils.emptyGuid(),
        "contractName": "",
        "contractCode": null,
        "beginDate": null,
        "endDate": null,
        "rate": 0
    };

    const newCompliance = {
        "contractorComplianceId": Utils.emptyGuid(),
        "companyId": Utils.emptyGuid(),
        "beginDate": null,
        "endDate": null,
        "complianceType": '',
        "status": "pass",
        "notes": "",
        "createDate": dayjs().format("YYYY-MM-DD"),
        "createUserId": Utils.emptyGuid(),
        "updateDate": dayjs().format("YYYY-MM-DD"),
        "updateUserId": Utils.emptyGuid(),
        "primeSubContractId": Utils.emptyGuid(),
    }

    const uploadTypes = [
        {
            "id": "1E870BF5-860A-4EE5-B25A-43F3499A6C8B",
            "name": "Carrier Disbursements"
        },
        {
            "id": "611D6077-94D4-4682-A367-B92573B8811C",
            "name": "Provider Deposits"
        }
    ]
    const [contract, setContract] = React.useState(newContract);
    const [companyList, setCompanyList] = React.useState([]);
    const [currentCompany, setCurrentCompany] = React.useState(null);
    const [checkingData, setCheckingData] = useState(true);
    const [openModal, setOpen] = useState(false);
    const [openUserModal, setOpenUser] = useState(false);
    const [columnsArray, setColumnsArray] = useState([]);
    const [fetchedData, setFetchedData] = useState([]);
    const [canEdit, setCanEdit] = useState(props.canEdit ?? true)
    const [openRejectModal, setOpenRejectModal] = useState(false);
    const [openApproveModal, setOpenApproveModal] = useState(false);
    const [openAddComplianceModal, setOpenAddComplianceModal] = useState(false);
    const [hasError, setHasError] = useState(false);
    const [currentFile, setCurrentFile] = useState(null)
    const [rejectNotes, setRejectNotes] = useState('')
    const [currentCompliance, setCurrentCompliance] = useState(newCompliance)
    const [complianceTypes, setComplianceTypes] = useState([
        'ACA Compliance',
        'Carrier Disbursements',
        'Cash in lieu',
        'Contract Updates',
        'Provider Deposits',
    ])
    const [showComplianceHistory,setShowComplianceHistory] = useState('')
    const [lockComplianceType, setLockComplianceType] = useState(false)
    const [currentComplianceType, setCurrentComplianceType] = useState(null)
    const fetchCompanies = (currentCompany = null) => {
        //apiGet(apiUrls.getContractCompanyList)
        const start = dayjs().subtract(1, 'month')
        const end = dayjs()
        apiGet(primeApiUrls.getDashboard(start?.format('YYYY-MM-DD'), end?.format('YYYY-MM-DD')))
            .then((response) => {
                console.log('fetch company list')
                console.dir(response)
                setCompanyList(response.data)
                if (currentCompany != null) {
                    // setOpen(false)
                    handleEdit(response.data.find(c => c.id == currentCompany.id))
                    //setCurrentCompany(findCompany(currentCompany.id))
                }
            })
            .catch(function (error) {
                // console.log("THIS IS ERROR", error);
            })
            .then(function () {
                // always executed

            });
    }

    const findCompany = (id) => {
        return companyList.find(c => c.id == id)
    }
    const handleEdit = (company) => {
        setOpen(true);
        console.log('edit')
        console.log(company)
        setCurrentCompany(company)
        setShowComplianceHistory('')
        // contract.beginDate = moment(contract.beginDate).format("MM/DD/YYYY")
        // contract.endDate = moment(contract.endDate).format("MM/DD/YYYY")
        // setContract(contract)
        // reset(contract)
    }
    const handleClose = () => {
        setOpen(false);
        //setAnchorEl(null);
    };
    const handleContractUserClose = () => {
        setOpenUser(false);
        //setAnchorEl(null);
    };

    const showAddModal = () => {
        setContract(newContract);
        setOpen(true);
        reset(newContract)
    };

    const showAddUserModal = () => {
        setOpenUser(true);
    };

    const handleComplianceChange = (propName, propValue) => {
        let obj = { ...currentCompliance }
        obj[propName] = propValue

        if ((propName == 'beginDate' || propName == 'endDate') && propValue == '') {
            obj[propName] = null
        }

        if ((propName == 'beginDate' && propValue != '')) {
            console.log('prop is beginDate')
            //validationSchema.isValid().then(() => {
            console.log('valid')
            let newEndDate = dayjs(propValue).add(1, 'year').subtract(1, 'day').format('YYYY-MM-DD')
            //handleContractChange('endDate', dayjs(propValue).add(1,'year').subtract(1,'day').format('YYYY-MM-DD'))
            obj['endDate'] = newEndDate
            setValue('endDate', newEndDate, { shouldValidate: false })
            //});
        }
        setCurrentCompliance(obj)
        console.log(propName)
        console.log(propValue)
        setValue(propName, propValue, { shouldValidate: true })
        validationSchema
            .validate(obj)
            .then(function (value) {
                console.log('yes')
                console.log(value); // returns CurrentCompliance object
                setHasError(false)
            })
            .catch(function (err) {
                console.log('err')
                console.log(err);
                setHasError(true)
            });

    };

    const handleReject = (file) => {
        console.log(file)
        setCurrentFile(file)
        setRejectNotes(null)
        setOpenRejectModal(true)
    }

    const handleRejectSubmit = () => {
        setSavingData(true)
        console.log('reject notes')
        console.log(rejectNotes)
        console.log(currentFile)

        apiPost(primeApiUrls.rejectUpload(currentFile.companyId, currentFile.userUploadId, null), { Notes: rejectNotes })
            .then((response) => {
                setOpenRejectModal(false)
            })
            .catch(function (error) {
                console.log('error')
                console.log(error)
            })
            .then(function () {
                setSavingData(false)
            });
    }


    const handleApprove = (file) => {
        console.log(file)
        setCurrentFile(file)
        let obj = { ...newCompliance }
        obj['companyId'] = currentCompany.id
        obj['status'] = "pass"
        const ut = (uploadTypes.filter(u => u.name == file.userUploadTypeName))

        if (ut.length == 1) {
            console.log('setLockComplianceType true')
            setCurrentComplianceType(ut[0].name)
            obj['complianceType'] = ut[0].name
            setLockComplianceType(false)
            obj['complianceType'] = ut[0].name
        }
        else {
            setCurrentComplianceType(null)
            obj['complianceType'] = ''
            setLockComplianceType(true)
        }
        setOpenApproveModal(true)

        setCurrentCompliance(obj)
    }

    const handleApproveSubmit = () => {
        console.log('approve')
        console.log(currentFile)
        console.log(currentCompliance)
        apiPost(primeApiUrls.postCompliance(currentFile.companyId, currentFile.userUploadId), currentCompliance)
            .then((response) => {
                console.log('response')
                console.log(response)
                setOpenApproveModal(false)
                setCurrentCompliance({ ...newCompliance })

            })
            .catch(function (error) {
                console.log('error')
                console.log(error)
            })
            .then(function () {
                // setSavingData(false)
            });
    }

    const handleAddCompliance = () => {
        let obj = { ...newCompliance }
        obj['companyId'] = currentCompany.id
        obj['status'] = "pass"
        setCurrentComplianceType(null)
        setLockComplianceType(false)
        setOpenAddComplianceModal(true)
        setHasError(true)
        setCurrentCompliance(obj)
    }

    const handleAddComplianceSubmit = () => {
        console.log('add compliance')
        console.log(currentCompliance)
        apiPost(primeApiUrls.postCompliance(currentCompany.id, null), currentCompliance)
            .then((response) => {
                console.log('response')
                console.log(response)
                setOpenAddComplianceModal(false)
                setCurrentCompliance({ ...newCompliance })
                fetchCompanies(currentCompany)
            })
            .catch(function (error) {
                console.log('error')
                console.log(error)
            })
            .then(function () {
                // setSavingData(false)
            });
    }

    useEffect(() => {
        setColumnsArray(columns)
    }, []);

    useEffect(() => {
        // if (currentCompany != null) {
        //     let companyId = currentCompany
        //     fetchContracts(companyId)
        // }
        fetchCompanies()
    }, [props.refresh]);

    let columns = [
        {
            Header: "Action",
            accessor: (cell) => (
                <IconButton color="primary" aria-label="Edit" component="span"
                    onClick={() => handleEdit(cell)} >
                    <EditOutlinedIcon />
                </IconButton>),
            disableFilters: true,
            className: (canEdit ? "" : "invisible")
        },
        {
            Header: "Company Name",
            accessor: "name",
        },
        {
            Header: "Pending Action",
            // accessor: "userUploads",
            accessor: (cell) => (cell.userUploads.map(u => u.fileName).join('')),
            Cell: ({ row }) => (
                <ul>
                    {row.original.userUploads.map(u => <li key={row.id}>Review {u.userUploadTypeName} file <b>{u.fileName}</b> Uploaded by {u.updateUserFirstName} {u.updateUserLastName}</li>)}
                </ul>
            ),
        },
        {
            Header: "Status",
            accessor: "status.value",
            Cell: ({ row }) => (
                <>{(row.original.status.value > 0 ? <Chip label="Pass" color="success" /> : <Chip label="Failed" color="error" />)}</>
            ),
        }
    ];

    const initialTableState = {
        sortBy: [
            {
                id: 'name',
                desc: false
            }
        ]
    }
    const options = {
        filter: true,
        filterType: "dropdown",
        responsive: "standard",
        viewColumns: true,
        download: false,
        print: false,
        textLabels: {
            body: {
                noMatch:
                    fetchedData !== undefined ? (
                        <LoaderAnimation />
                    ) : (
                        "Sorry, there is no data to show"
                    ),
            },
        },
        searchProps: { variant: "standard" }
    };

    const statusToChip = (status) => {
        if (status == "pass") {
            return <Chip label="Pass" color="success" />
        }
        if (status == "failed") {
            return <Chip label="Failed" color="error" />
        }
        if (status == "missing") {
            return <Chip label="Missing" color="warning" />
        }
        return <></>
    }
    const showComplianceList = (compliances) => {
        if (compliances) {
            console.log(compliances)
            compliances.sort((a, b) => {
                // return new Date(b.updateDate) - new Date(a.updateDate);
                return b.updateDate - a.updateDate;
            });


            // currentCompany?.compliances.map((c, idx) => <li key={`complianceType-${idx}`}>{c.complianceType} {c.status == "missing" ? "is missing" : `${c.status} from ${moment(c.beginDate).format("MM/DD/YYYY")} to ${moment(c.endDate).format("MM/DD/YYYY")}, updated ${moment(c.updateDate).format("MM/DD/YYYY")}`}</li>)
            return <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                {
                    complianceTypes.map((t) => {
                        const complianceList = compliances.filter(c => c.complianceType == t)
                        return <><ListItemButton onClick={()=>{showComplianceHistory==t?setShowComplianceHistory(''):setShowComplianceHistory(t)}} >
                            <ListItemText primary={<><b>{t}</b>  {statusToChip(complianceList[0].status)} {complianceList[0].status=="missing"?"":<>{moment(complianceList[0].beginDate).format("MM/DD/YYYY")} - {moment(complianceList[0].endDate).format("MM/DD/YYYY")}</>}</>} />
                            {showComplianceHistory==t?<ExpandLess />:<ExpandMore/>}
                        </ListItemButton>

                            {complianceList.map((c, idx) => <>
                                <Collapse in={showComplianceHistory==t} timeout="auto" unmountOnExit>
                                    <List component="div" sx={{paddingLeft:'50px', bgcolor: 'ghostwhite'}} >
                                        {c.status=="missing"?<></>:<ListItemText primary={<>{moment(c.updateDate).format("MM/DD/YYYY")} update to {statusToChip(c.status)} <br/> [{moment(c.beginDate).format("MM/DD/YYYY")} - {moment(c.endDate).format("MM/DD/YYYY")}]</>} />}                                       
                                    </List>
                                </Collapse>

                            </>
                            )}</>
                    })
                }
            </List>
        }
        return <></>
    }
    return (
        <>
            {/* Add MODAL */}
            <Dialog
                open={openModal}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                className={TableStyle.fileTypeModalWrapper}
                fullWidth
            >
                <DialogTitle id="alert-dialog-slide-title">
                {currentCompany?.name} Compliance
                </DialogTitle>
                <DialogContent>
                    <Box
                        component="form"
                        sx={{
                            '& .MuiTextField-root': { m: 1, width: '25ch' },
                        }}
                        noValidate
                        autoComplete="off"
                    >
                        <div>
                            <ul>
                                {currentCompany?.userUploads.map((u, idx) =>
                                    <li key={`userUpload-${idx}`}>
                                        Review {u.userUploadTypeName} file <a href="">{u.fileName}</a> Uploaded by {u.updateUserFirstName} {u.updateUserLastName}
                                        <Button onClick={() => { handleApprove(u) }}>Approve</Button><Button onClick={() => { handleReject(u) }}>Reject</Button>
                                    </li>)}
                            </ul>
                            {
                                showComplianceList(currentCompany?.compliances)
                                //currentCompany?.compliances.map((c, idx) => <li key={`complianceType-${idx}`}>{c.complianceType} {c.status == "missing" ? "is missing" : `${c.status} from ${moment(c.beginDate).format("MM/DD/YYYY")} to ${moment(c.endDate).format("MM/DD/YYYY")}, updated ${moment(c.updateDate).format("MM/DD/YYYY")}`}</li>)
                            }
                        </div>
                    </Box>
                </DialogContent>
                <DialogActions className={ButtonStyle.buttonWrapper}>
                    <Button
                        variant="outlined"
                        onClick={handleAddCompliance}
                        disabled={savingData}
                    >
                        {(savingData ? "Saving" : "Add Compliance")}
                    </Button>
                    <Button onClick={handleClose} className={ButtonStyle.CcancelBtn}>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Reject  MODAL */}
            <Dialog
                open={openRejectModal}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => { setOpenRejectModal(false) }}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                className={TableStyle.fileTypeModalWrapper}
                fullWidth
            >
                <DialogTitle id="alert-dialog-slide-title">
                    Reject File
                </DialogTitle>
                <DialogContent>
                    <Box
                        component="form"

                        noValidate
                        autoComplete="off"
                    >
                        <div>Review {currentFile?.fileName}</div>
                        <TextField label="Notes"
                            multiline={true}
                            value={rejectNotes}
                            fullWidth
                            onChange={(event) => setRejectNotes(event.target.value)}></TextField>
                    </Box>
                </DialogContent>
                <DialogActions className={ButtonStyle.buttonWrapper}>
                    <Button
                        variant="outlined"
                        onClick={() => { handleRejectSubmit() }}
                        disabled={savingData}
                    >
                        {(savingData ? "Saving" : "Save")}
                    </Button>
                    <Button onClick={() => { setOpenRejectModal(false) }} className={ButtonStyle.CcancelBtn}>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Approve  MODAL */}
            <Dialog
                open={openApproveModal}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => { setOpenApproveModal(false) }}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                className={TableStyle.fileTypeModalWrapper}
                fullWidth
            >
                <DialogTitle id="alert-dialog-slide-title">
                    Approve Compliance
                </DialogTitle>
                <DialogContent>
                    <Box
                        component="form"
                        sx={{
                            '& .MuiTextField-root': { m: 1, width: '25ch' },
                        }}
                        noValidate
                        autoComplete="off"
                    >
                        <div>
                            <h2>{currentFile?.fileName}</h2>
                        </div>

                        <div >
                            <FormControl className={TableStyle.payperiodDropdownWrapper}>
                                <InputLabel id="complianceType-dropdown" shrink>
                                    Compliance Type
                                </InputLabel>
                                <Select
                                    variant="standard"
                                    labelId="complianceType-dropdown"
                                    required
                                    shrink
                                    value={currentCompliance.complianceType}
                                    //onChange={e => setCurrentComplianceType(e.target.value)}
                                    onChange={(e) => handleComplianceChange('complianceType', e.target.value)}
                                    error={errors.complianceType ? true : false}
                                    readOnly={lockComplianceType}
                                >
                                    <MenuItem value={''} key={-1}>Select a value</MenuItem>
                                    {complianceTypes.map((item, i) => {
                                        return (<MenuItem key={`complianceType-${i}`} value={item}>{item}</MenuItem>);
                                    })}
                                </Select>
                            </FormControl>

                        </div>
                        <div>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    // {...register('beginDate')}
                                    id="beginDate"
                                    name="beginDate"
                                    minDate={dayjs('01/01/1900')}
                                    value={dayjs(currentCompliance.beginDate)}
                                    onChange={(newValue) => handleComplianceChange('beginDate', newValue?.format('YYYY-MM-DD'))}
                                    label="Begin Date"
                                    slotProps={{
                                        textField: {
                                            helperText: errors.beginDate?.message,
                                        },
                                    }}
                                />
                            </LocalizationProvider>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    // {...register('endDate')}
                                    id="endDate"
                                    name="endDate"
                                    minDate={dayjs('01/01/1900')}
                                    value={dayjs(currentCompliance.endDate)}
                                    onChange={(newValue) => handleComplianceChange('endDate', newValue?.format('YYYY-MM-DD'))}
                                    label="End Date"
                                    slotProps={{
                                        textField: {
                                            helperText: errors.endDate?.message,
                                        },
                                    }}
                                />
                            </LocalizationProvider>

                        </div>
                        <div>
                            <TextField label="Notes"
                                multiline={true}
                                value={currentCompliance.notes}
                                onChange={(event) => handleComplianceChange('notes', event.target.value)}></TextField>
                        </div>
                    </Box>

                </DialogContent>
                <DialogActions className={ButtonStyle.buttonWrapper}>

                    <Button
                        variant="outlined"
                        onClick={handleApproveSubmit}
                        disabled={savingData}
                    >
                        {(savingData ? "Saving" : "Save")}
                    </Button>
                    <Button onClick={() => { setOpenApproveModal(false) }} className={ButtonStyle.CcancelBtn}>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>


            {/* Add Compliance  MODAL */}
            <Dialog
                open={openAddComplianceModal}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => { setOpenAddComplianceModal(false) }}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                className={TableStyle.fileTypeModalWrapper}
                fullWidth
            >
                <DialogTitle id="alert-dialog-slide-title">
                    Add Compliance
                </DialogTitle>
                <DialogContent>
                    <Box
                        component="form"
                        sx={{
                            '& .MuiTextField-root': { m: 1, width: '25ch' },
                        }}
                        noValidate
                        autoComplete="off"
                    >
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                                <FormControl className={TableStyle.payperiodDropdownWrapper} sx={{ m: 1, minWidth: 150 }}>
                                    <InputLabel id="add-compliance-complianceType-dropdown" shrink>
                                        Compliance Type
                                    </InputLabel>
                                    <Select
                                        variant="standard"
                                        labelId="add-compliance-complianceType-dropdown"
                                        required
                                        shrink
                                        value={currentCompliance.complianceType}
                                        //onChange={e => setCurrentComplianceType(e.target.value)}
                                        onChange={(e) => handleComplianceChange('complianceType', e.target.value)}
                                        error={errors.complianceType ? true : false}
                                    >
                                        <MenuItem value={''} key={-1}>Select a value</MenuItem>
                                        {complianceTypes.map((item, i) => {
                                            return (<MenuItem key={`complianceType-${i}`} value={item}>{item}</MenuItem>);
                                        })}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl className={TableStyle.payperiodDropdownWrapper} sx={{ m: 1, minWidth: 150 }}>
                                    <InputLabel id="complianceStatus-dropdown" shrink>
                                        Status
                                    </InputLabel>
                                    <Select
                                        variant="standard"
                                        labelId="complianceStatus-dropdown"
                                        required
                                        shrink
                                        value={currentCompliance.status}
                                        //onChange={e => setCurrentComplianceType(e.target.value)}
                                        onChange={(e) => handleComplianceChange('status', e.target.value)}
                                        error={errors.complianceType ? true : false}
                                    >
                                        <MenuItem value="pass" key={`status0`}>Pass</MenuItem>
                                        <MenuItem value="failed" key={`status1`}>Failed</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        // {...register('beginDate')}
                                        id="beginDate"
                                        name="beginDate"
                                        minDate={dayjs('01/01/1900')}
                                        value={dayjs(currentCompliance.beginDate)}
                                        onChange={(newValue) => handleComplianceChange('beginDate', newValue?.format('YYYY-MM-DD'))}
                                        label="Begin Date"
                                        slotProps={{
                                            textField: {
                                                helperText: errors.beginDate?.message,
                                            },
                                        }}
                                    />
                                </LocalizationProvider>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        // {...register('endDate')}
                                        id="endDate"
                                        name="endDate"
                                        minDate={dayjs('01/01/1900')}
                                        value={dayjs(currentCompliance.endDate)}
                                        onChange={(newValue) => handleComplianceChange('endDate', newValue?.format('YYYY-MM-DD'))}
                                        label="End Date"
                                        slotProps={{
                                            textField: {
                                                helperText: errors.endDate?.message,
                                            },
                                        }}
                                    />
                                </LocalizationProvider>

                            </Grid>
                            <Grid item xs={12}>
                                <TextField label="Notes"
                                    multiline={true}
                                    value={currentCompliance.notes}
                                    onChange={(event) => handleComplianceChange('notes', event.target.value)}></TextField>

                            </Grid>
                        </Grid>
                    </Box>

                </DialogContent>
                <DialogActions className={ButtonStyle.buttonWrapper}>
                    <Button
                        variant="outlined"
                        onClick={handleAddComplianceSubmit}
                        disabled={savingData || hasError}
                    >
                        {(savingData ? "Saving" : "Save")}
                    </Button>
                    <Button onClick={() => { setOpenAddComplianceModal(false) }} className={ButtonStyle.CcancelBtn}>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
            <TableAllData
                className={TableStyle.TimeSheetsWrapper}
                columns={columnsArray}
                data={companyList}
                initialState={initialTableState}
            />
        </>
    )
}